import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import { store } from '@store';
import { router } from '@routes';
import ErrorBoundary from '@components/common/ErrorBoundary';
import { FeedbackProvider } from '@contexts/FeedbackContext';
import { TourProvider } from '@contexts/TourContext';
import { MentorTourProvider } from '@contexts/MentorTourContext';
import PlanSelectionGuard from '@components/common/PlanSelectionGuard';
import PermissionsInitializer from '@components/common/PermissionsInitializer';

function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <PermissionsInitializer>
          <FeedbackProvider>
            <TourProvider>
              <MentorTourProvider>
                <PlanSelectionGuard>
                  <RouterProvider router={router} />
                </PlanSelectionGuard>
              </MentorTourProvider>
            </TourProvider>
          </FeedbackProvider>
        </PermissionsInitializer>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: 'rgba(255, 255, 255, 0.85)',
              color: '#1f2937',
              backdropFilter: 'blur(12px)',
              WebkitBackdropFilter: 'blur(12px)',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              borderRadius: '8px',
              padding: '12px 16px',
              border: '1px solid rgba(255, 255, 255, 0.3)',
            },
            success: {
              style: {
                background: 'rgba(240, 253, 244, 0.85)',
                color: '#065f46',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                border: '1px solid rgba(16, 185, 129, 0.3)',
              },
              iconTheme: {
                primary: '#10b981',
                secondary: '#fff',
              },
            },
            error: {
              style: {
                background: 'rgba(254, 242, 242, 0.85)',
                color: '#991b1b',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                border: '1px solid rgba(239, 68, 68, 0.3)',
              },
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
